import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import Store from "../../index";
import { api } from "@/lib";

@Module({ name: "alerts", dynamic: true, store: Store, namespaced: true })
export default class AlertModule extends VuexModule {
  @Action
  async getOrderAlertCounts(payload) {
    let url = `/orderAlerts/counts`;

    if (payload && payload.facilityCodes && payload.facilityCodes.length > 0) {
      var facilityParam = "facilityCodes=" + payload.facilityCodes.join("&facilityCodes=");
    }

    if (payload && payload.deliveryForIds && payload.deliveryForIds.length > 0) {
      var deliveryParam = "deliveryForIds=" + payload.deliveryForIds.join("&deliveryForIds=");
    }

    if (facilityParam || deliveryParam) {
      url += "?" + (facilityParam ? facilityParam : "") + (facilityParam ? '&' : '') + (deliveryParam ? deliveryParam : "");
    }

    return await api.getAsync(url);
  }
}
